<template>
  <div class="row">
    <!--  申请课程列表  -->
    <div class="flex xs12">
      <va-card title="申请课程列表">
        <div class="row align--center mb-1">
          <div class="flex xs12">
            <va-button-group>
              <va-button class="mb-2" flat disabled color="gray">课程类型：</va-button>
              <va-button class="mb-2" :color="!serviceType ? 'info' : 'gray'" flat  v-on:click="handleServiceTypeChange(null)" >全部</va-button>
              <va-button
                class="mb-2"
                v-for="serviceType in serviceTypes"
                :key="serviceType.CODE"
                :color="computeServiceTypeColor(serviceType.CODE)"
                flat
                v-on:click="handleServiceTypeChange(serviceType.CODE)"
              >{{serviceType.TEXT}}</va-button>
            </va-button-group>
            <va-button-group>
              <va-button class="mb-2" flat disabled color="gray">处理状态：</va-button>
              <va-button :color="computeStatusColor(null)" class="mb-2" flat  v-on:click="handleStatusChange(null)" >全部</va-button>
              <va-button
                class="mb-2"
                v-for="status in appliedCourseStatusTypes"
                :key="status.CODE"
                :color="computeStatusColor(status.CODE)"
                flat
                v-on:click="handleStatusChange(status.CODE)"
              >
                {{status.TEXT}}
              </va-button>
              <va-button class="mb-2" flat disabled color="danger">总计{{totalCount}}条结果</va-button>
            </va-button-group>

          </div>
          <!--    用户uid筛选      -->
          <div class="flex md6 xs12 sm6">
            <va-input
              :value="userUid"
              placeholder="搜索学员uid"
              @input="searchUserUid"
              removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
          <!--   课程id筛选       -->
          <div class="flex md6 xs12 sm6">
            <va-input
              v-show="!!serviceType"
              :value="serviceId"
              placeholder="搜索课程ID"
              @input="searchServiceId"
              removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
        </div>
        <va-data-table
          :fields="fields"
          :data="appliedCourses"
          :loading="loading"
          :totalPages="totalPages"
          class="force-wrap"
          @page-selected="listAppliedCourse"
          api-mode
        >
          <template slot="avatar" slot-scope="props">
            <img :src="props.rowData.user.avatar" class="data-table-server-pagination---avatar" alt="avatar">
          </template>
          <template slot="user" slot-scope="props">
            <va-button color="gray" flat small :to='{path:`/admin/users/updateUser/${props.rowData.user.uid}`}'>
              {{ props.rowData.user.nickname }}
            </va-button>
          </template>
          <template slot="course" slot-scope="props">
            <va-button color="gray" flat small :to='{path:`/admin/services/${computedUpdateCoursePath(props.rowData.serviceType)}/${props.rowData.course.id}`}'>
              {{ props.rowData.course.name }}
            </va-button>
          </template>
          <template slot="statusSlot" slot-scope="props">
            <va-badge color= 'info'>
              {{ computeAppliedCourseStatus(props.rowData.status).text }}
            </va-badge>
          </template>
          <template slot="actions" slot-scope="props">
            <va-popover message="查看" placement="top">
              <va-button flat small color="gray" icon="fa fa-eye"
                :to='{path:`getAppliedCourse/${props.rowData.id}`}'/>
            </va-popover>
            <va-popover message="删除" placement="top">
              <va-button flat small color="gray" icon="fa fa-trash"
                @click="deleteModal = true;deleteId=props.rowData.id"/>
            </va-popover>
          </template>
        </va-data-table>

        <va-modal
          v-model="deleteModal"
          title="删除报名"
          okText="提交"
          position="center"
          message="请再次确认是否要删除？"
          @ok="confirmDelete"
        />

      </va-card>
    </div>
  </div>
</template>

<script>

import debounce from 'lodash/debounce'
import appliedCourseApi from '../../../api/appliedCourse'
import { APPLIED_SERVICE_TYPES, USER_APPLICATION_STATUS_TYPES } from '../../../utils/constants'
import { formatTime } from '@/utils/common'
export default {
  data () {
    return {
      message: ['Required field'],
      serviceId: this.$route.query.serviceId,
      serviceType: this.$route.query.serviceType,
      userUid: this.$route.query.userUid,
      appliedCourses: [],
      loading: true,
      pageNumber: 1,
      pageSize: 10,
      totalPages: 1,
      totalCount: 0,
      deleteModal: false,
      deleteId: null,
      status: null,
      appliedCourseStatusTypes: USER_APPLICATION_STATUS_TYPES,
      serviceTypes: APPLIED_SERVICE_TYPES,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:avatar',
          title: '学员头像',
          width: '60px',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:user',
          title: '学员姓名',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:statusSlot',
          title: '处理状态',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:course',
          title: '课程名称',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'createTime',
          title: '申请时间',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:actions',
          title: '操作',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
  },
  created () {
    this.listAppliedCourse()
  },
  methods: {
    listAppliedCourse (pageNumber = this.pageNumber) {
      this.loading = true
      const params = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        userUid: this.userUid,
        serviceId: this.serviceId,
        serviceType: this.serviceType,
        status: this.status,
      }
      appliedCourseApi.listAppliedCourse(params).then(response => {
        this.appliedCourses = response.appliedCourses
        this.appliedCourses.forEach(x => {
          x.createTime = formatTime(x.createTime)
        })
        this.totalPages = response.pages.totalPage
        this.totalCount = response.pages.totalCount
        this.pageNumber = pageNumber
        this.loading = false
      }).catch(error => alert(error))
    },
    confirmDelete () {
      if (this.deleteUid === null) return
      appliedCourseApi.deleteAppliedCourse(this.deleteId).then(response => {
        if (response.success === true) {
          this.showToast('删除报名成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.listAppliedCourse()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    searchUserUid: debounce(function (userUid) {
      this.userUid = userUid
      if (this.userUid === '') { this.userUid = null }
      this.listAppliedCourse()
    }, 400),
    searchServiceType: debounce(function (serviceType) {
      this.serviceType = serviceType
      if (this.serviceType === '') { this.serviceType = null }
      this.listAppliedCourse()
    }, 400),
    searchServiceId: debounce(function (serviceId) {
      this.serviceId = serviceId
      if (this.serviceId === '') { this.serviceId = null }
      this.listAppliedCourse()
    }, 400),
    computeStatusColor (status) {
      return status === this.status ? 'info' : 'gray'
    },
    handleStatusChange (status) {
      this.status = status
      this.listAppliedCourse()
    },
    computeServiceTypeColor (serviceType) {
      return serviceType === this.serviceType ? 'info' : 'gray'
    },
    handleServiceTypeChange (serviceType) {
      this.serviceType = serviceType
      this.listAppliedCourse()
    },
    computeAppliedCourseStatus (status) {
      const data = {
        text: '',
      }
      this.appliedCourseStatusTypes.map(x => {
        if (x.CODE === status) {
          data.text = x.TEXT
        }
      })
      return data
    },
    computedUpdateCoursePath (serviceType) {
      console.log(serviceType)
      let res = ''
      this.serviceTypes.forEach(x => {
        if (x.CODE === serviceType) {
          res = x.COURSE_PATH
        }
      })
      return res
    },
  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
</style>
<style lang="scss">
.force-wrap td {
  word-break: break-word; /* 文本行的任意字内断开 */
  word-wrap: break-word; /* IE */
  white-space: -moz-pre-wrap; /* Mozilla */
  white-space: -hp-pre-wrap; /* HP printers */
  white-space: -o-pre-wrap; /* Opera 7 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: pre; /* CSS2 */
  white-space: pre-wrap; /* CSS 2.1 */
  white-space: pre-line; /* CSS 3 (and 2.1 as well, actually) */
}
</style>
